import type { InternalRequest } from '../client.js';

// Fuel module — mirrors server/src/fuel/reads.ts OverviewRow. A 403
// `module_disabled` means the org does not have the module.

export type FuelOverviewStatus = 'ok' | 'low' | 'no_data' | 'unconfigured' | (string & {});

export interface FuelOverviewRow {
  deviceId: number;
  deviceName: string;
  profileId: string | null;
  levelSource: string | null;
  levelKey: string | null;
  tankLitres: number | null;
  litres: number | null;
  percent: number | null;
  status: FuelOverviewStatus;
  lastFixAt: string | null;
  lastEvent: { type: 'fill' | 'drain'; deltaL: number; endedAt: string } | null;
  suggested: boolean;
}

export interface FuelOverviewResponse {
  vehicles: FuelOverviewRow[];
  counts: { low: number; noData: number; unconfigured: number };
}

export function fuelEndpoints(req: InternalRequest) {
  return {
    /** GET /api/fuel/overview — one row per org vehicle, profile-derived litres/percent. */
    overview: () => req.request<FuelOverviewResponse>('/fuel/overview'),
  };
}
